"use client";

import Script from "next/script";

const clarityTagId = process.env.NEXT_PUBLIC_CLARITY_TAG_ID;
const isProduction = process.env.NODE_ENV === "production";

export function ClarityAnalyticsScript() {
	if (!isProduction || !clarityTagId) return null;

	return (
		<Script
			id="microsoft-clarity"
			strategy="afterInteractive"
			onError={(e) => {
				console.error("Clarity script error:", e);
			}}
		>
			{`
				(function(c,l,a,r,i,t,y){
					c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
					t=l.createElement(r);t.async=1;
					t.crossOrigin="anonymous";
					t.src="https://www.clarity.ms/tag/"+i;
					t.onerror=function(e){console.error("Clarity load error:",e);};
					y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
				})(window, document, "clarity", "script", "${clarityTagId}");
			`}
		</Script>
	);
}

export function useClarityAnalytics() {
	const trackEvent = (event: string, data: Record<string, unknown>) => {
		if (!isProduction) {
			return;
		}

		// call your analytics service to track a custom event here
		console.info("tracking event", event, data);

		if (typeof window !== "undefined" && (window as any).clarity) {
			(window as any).clarity("event", event, data);
		}
	};

	return {
		trackEvent,
	};
}
